import Vue from 'vue'
import store from '../store/index'

export function getResourceUrl(resName) {
    const assets = store.state.hospital.assets;
    if (!assets)
        return "";
    var res = assets.find(it => {
        return it.name == resName
    });
    if (!res)
        return ""
    else
        return res.value;
}

export var icons = {
    icon_hospital: getResourceUrl('--icon-hospital'),
    icon_report: getResourceUrl('--icon-report')
}

export var pics = {
    bg_user_login: getResourceUrl('--bg-user-login'),
    bg_user_center: getResourceUrl('--bg-user-center')
}